import { useCallback, useContext } from 'react';

import { riskTypes } from '../../../../providers/risk-management/risk-filters-provider';
import { RiskManagementContext } from '../../../../providers/risk-management/risk-management-provider';
import { IAccountOption } from '../../../../providers/portfolio-management/portfolio-management.types';

type UseIsSpotLoadedReturn = {
  isSpotLoaded: (
    dataParent: string,
    accountParams?: {
      accountOption: IAccountOption;
      exchange: string;
      riskToken: string;
    },
  ) => boolean;
};

export const useIsSpotLoaded = (): UseIsSpotLoadedReturn => {
  const {
    riskLoadings: {
      isSpotLadderQuoteLoading,
      isSpotLadderBaseLoading,
      isSpotGridQuoteLoading,
      isSpotGridBaseLoading,
      isSpotTimeQuoteLoading,
      isSpotTimeBaseLoading,
    },
    isLoadingByParams,
  } = useContext(RiskManagementContext);

  const isSpotLoaded = useCallback(
    (
      dataParent: string,
      accountParams?: {
        accountOption: IAccountOption;
        exchange: string;
        riskToken: string;
      },
    ) => {
      const loadingStates: { [key: string]: boolean } = {
        [riskTypes.spotLadder]: isSpotLadderQuoteLoading || isSpotLadderBaseLoading,
        [riskTypes.spotGrid]: isSpotGridQuoteLoading || isSpotGridBaseLoading,
        [riskTypes.spotTime]: isSpotTimeQuoteLoading || isSpotTimeBaseLoading,
      };

      const globalLoading = loadingStates[dataParent];

      if (!accountParams) {
        return !globalLoading;
      }

      const accountLoading = isLoadingByParams({
        matrix: dataParent,
        account: accountParams.accountOption?.name,
        exchange: accountParams.exchange,
        riskToken: accountParams.riskToken,
      });

      return !accountLoading;
    },
    [
      isSpotLadderQuoteLoading,
      isSpotLadderBaseLoading,
      isSpotGridQuoteLoading,
      isSpotGridBaseLoading,
      isSpotTimeQuoteLoading,
      isSpotTimeBaseLoading,
      isLoadingByParams,
    ],
  );

  return { isSpotLoaded };
};
